import { TableHeadersType } from "../tableHeadersType";

export const FIXED_ASSET_HEADERS: TableHeadersType[] = [
  {
    label: "Finac Asset ID",
    value: "finac_asset_id",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Asset ID",
    value: "asset_id",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Asset Description",
    value: "asset_description",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Location",
    value: "location",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Department",
    value: "department",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Condition",
    value: "condition",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Files",
    value: "attachment_count",
  },
  {
    label: "Asset Assigned To",
    value: "is_assigned",
  },
  {
    label: "lAST UPDATED",
    value: "lAST UPDATED",
  },
  {
    label: "LAST VERIFIED BY",
    value: "LAST VERIFIED BY",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "QR CODE IMAGE",
    value: "QR CODE IMAGE",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Action",
    value: "action",
    checked: true,
    defaultChecked: true,
  },
];
